import type { MenuSchema } from '../MenuSchema.js';

export const AVATAR_MENU_ACTIONS = {
    previous: 'avatar-prev',
    next: 'avatar-next',
    select: 'avatar-select',
} as const;

export const AVATAR_MENU_LABELS = {
    title: 'Avatar',
    subtitle: 'Preview and select your avatar model',
    previous: 'Previous',
    next: 'Next',
    select: 'Select Avatar',
    noAvatars: 'No avatars configured.',
    previewPrefix: 'Preview:',
    activePrefix: 'Active:',
} as const;

export function createAvatarMenuSchema(): MenuSchema {
    return {
        id: 'AVATAR',
        title: AVATAR_MENU_LABELS.title,
        nodes: [
            { type: 'text', text: AVATAR_MENU_LABELS.subtitle },
            { type: 'button', id: AVATAR_MENU_ACTIONS.previous, label: AVATAR_MENU_LABELS.previous },
            { type: 'button', id: AVATAR_MENU_ACTIONS.next, label: AVATAR_MENU_LABELS.next },
            { type: 'button', id: AVATAR_MENU_ACTIONS.select, label: AVATAR_MENU_LABELS.select },
        ],
    };
}
